import { render, staticRenderFns } from "./OperaBussinessAreaWindow.vue?vue&type=template&id=6f1e792a&scoped=true"
import script from "./OperaBussinessAreaWindow.vue?vue&type=script&lang=js"
export * from "./OperaBussinessAreaWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaBussinessAreaWindow.vue?vue&type=style&index=0&id=6f1e792a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e792a",
  null
  
)

export default component.exports